import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const devices = () => {
  let check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

export default {
  install: (app, options) => {
    const isDevice = devices();

    const menu = {
      timeline: gsap.timeline({ paused: true }),
      init: (menuSelector = '.main-menu>li', subMenuSelector = '.domain-menu>li') => {
        const menuItems = document.querySelectorAll(menuSelector);
        const subMenuItems = document.querySelectorAll(subMenuSelector);

        if (menuItems.length) {
          gsap.set(menuItems, {
            autoAlpha: 0,
            translateX: "-10px"
          });
        }

        if (subMenuItems.length) {
          gsap.set(subMenuItems, {
            autoAlpha: 0,
            translateX: "-10px"
          });
        }

        menuItems.forEach((menuItem, index) => {
          const thisSubMenuItems = menuItem.querySelectorAll(subMenuSelector);
          const menuItemTimeline = gsap.timeline();

          if (index) {
            menuItemTimeline.delay(-0.25);
          }

          menuItemTimeline.to(menuItem, {
            autoAlpha: 1,
            translateX: "0px",
          });

          if (thisSubMenuItems.length) {
            menuItemTimeline.to(thisSubMenuItems, {
              autoAlpha: 1,
              translateX: "0px",
              delay: -0.25
              // stagger: 0.15
            });
          }

          menu.timeline.add(menuItemTimeline);
        });

        // menu.timeline
        //   .to(menuItems, {
        //     autoAlpha: 1,
        //     translateX: "0px",
        //     stagger: 0.15,
        //   })
        //   .to(subMenuItems, {
        //     autoAlpha: 1,
        //     translateX: "0px",
        //     stagger: 0.15,
        //   });
      },
      reveal: () => {
        menu.timeline.play();
      },
      reset: () => {
        menu.timeline.paused(true);
        menu.timeline.seek(0);
      },
    };

    const parallax = {
      init: () => {
        gsap.utils.toArray("[data-parallax]").forEach(element => {
          gsap.to(element, {
            scrollTrigger: {
              trigger: element,
              scrub: 2,
              // invalidateOnRefresh: true
              // markers: true,
            },
            y: (i, target) => `${element.dataset.parallax}vw`,
          });
        });
      }
    };

    const blocks = {
      namedTimelines: [],
      init: () => {
        const textBlocks = gsap.utils.toArray('[data-animation-block]');
        if (textBlocks.length) {
          textBlocks.forEach(block => {
            let animationTimeline;
            const animationBlockName = block.dataset.animationBlock;
            const masks = block.querySelectorAll('[data-animation-mask] span');
            const reveals = block.querySelectorAll('[data-animation-reveal]>*');

            animationTimeline = gsap
              .timeline({
                scrollTrigger: {
                  trigger: block,
                  start: "0% 100%",
                  end: "0% 100%",
                  toggleActions: `${animationBlockName ? 'none' : 'play'} none reset none`,
                  // markers: true
                },
              });

            if (masks.length) {
              animationTimeline.to(masks, {
                y: 0,
                opacity: 1,
                stagger: 0.05,
                duration: 1,
              });
            }

            if (reveals.length) {
              animationTimeline.to(reveals, {
                x: 0,
                y: 0,
                opacity: 1,
                stagger: 0.25,
                duration: 1,
                delay: masks.length ? -0.5 : 0
              });
            }

            if (animationBlockName) {
              const camelCaseName = animationBlockName
                .replace(/-([a-z])/g, (match, letter) => letter.toUpperCase())
                .replace(/-(\d+)/g, (match, number) => number);

              blocks.namedTimelines.push({
                [camelCaseName]: animationTimeline
              })
            }
          });
        }
      },
      play: name => {
        const camelCaseName = name
          .replace(/-([a-z])/g, (match, letter) => letter.toUpperCase())
          .replace(/-(\d+)/g, (match, number) => number);

        const timeline = blocks.namedTimelines.find(timeline => timeline[camelCaseName]);

        if (timeline && timeline[camelCaseName]) {
          timeline[camelCaseName].play();
        }
      }
    };

    const counter = {
      effect: {
        name: "count",
        extendTimeline: true,
        defaults: {
          end: 0,
          duration: 0.5,
          ease: "power1",
          increment: 1,
          decimals: 0
        },
        effect: (targets, config) => {
          let tl = gsap.timeline({
            scrollTrigger: {
              trigger: targets[0],
              start: "top 100%",
              end: "top 100%",
              toggleActions: "play none reset none",
              // markers: true
            },
          })
          let num = targets[0].innerText.replace(/\,/g, '')
          targets[0].innerText = num

          tl.to(targets, {
            duration: config.duration,
            innerText: config.end,
            modifiers: {
              innerText: function (innerText) {
                return gsap.utils.snap(config.increment, innerText).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              }
            },
            ease: config.ease
          }, 0)

          return tl;
        }
      },
      init: () => {
        gsap.registerEffect(counter.effect);

        gsap.utils.toArray("[data-count]").forEach(element => {
          gsap.effects.count(element, {
            duration: 2,
            end: element.dataset.count,
            increment: element.dataset.countStep ?? 1,
            decimals: element.dataset.countDecimals ?? 0
          });
        });
      }
    };

    const followMouse = {
      effect: (e, el, reverse = false) => {
        let xTo = gsap.quickTo(el, "x", { duration: 2, ease: "power3" }),
          yTo = gsap.quickTo(el, "y", { duration: 0.4, ease: "power3" });

        let x = 0.05 * (window.innerWidth / 2 - e.x);
        let y = 0.05 * (window.innerHeight / 2 - e.y);

        if (reverse) {
          x = -x;
          y = -y;
        }

        xTo(x);
        yTo(y);
      },
      init: () => {
        const followMouseEls = gsap.utils.toArray('[data-follow-mouse]');
        followMouseEls.forEach(el => {
          if (!isDevice) {
            el.addEventListener("mousemove", (e) => {
              followMouse.effect(e, el, el.dataset.followMouseReverse === 'true');
            });
          }
        });
      },
    }

    const animations = { menu, parallax, blocks, counter, followMouse };
    app.config.globalProperties.$animations = animations;
    app.provide('$animations', animations);
  }
}